var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 30,
    viewBox: "0 0 23 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75 23.7762C7.50159 25.8668 9.42493 27.8071 11.5 29.5771C13.575 27.8071 15.4984 25.8668 17.2499 23.7762C19.8785 20.6367 22.9999 15.9612 22.9999 11.5058C23.0048 9.99489 22.7098 8.49806 22.1323 7.10188C21.5548 5.7057 20.7061 4.43794 19.6354 3.37196C18.0272 1.76228 15.9775 0.665846 13.746 0.221449C11.5143 -0.222948 9.20105 0.00471348 7.09888 0.875502C4.99671 1.74629 3.20007 3.22121 1.9364 5.11348C0.672792 7.00575 -0.00112773 9.23036 1.41659e-06 11.5058C1.41659e-06 15.9612 3.1214 20.6367 5.75 23.7762ZM11.5 18.8272C15.366 18.8272 18.5 15.6931 18.5 11.8272C18.5 7.9612 15.366 4.82716 11.5 4.82716C7.63403 4.82716 4.5 7.9612 4.5 11.8272C4.5 15.6931 7.63403 18.8272 11.5 18.8272Z",
    fill: "url(#paint0_linear_148_3)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_148_3",
    x1: 0,
    y1: 14.7886,
    x2: 23,
    y2: 14.7886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A32731"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D71524"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.7388c083f8c211b56ffcb454811ad5c6.svg";
export { ForwardRef as ReactComponent };